<template>
  <div :key="childKey" class="WithForceRerender">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ForceRerender",
  data() {
    return {
      childKeyIdx: 0,
      componentID: null,
    };
  },
  computed: {
    childKey() {
      return `rerender-wrapper-${this.componentID}-${this.childKeyIdx}`;
    },
  },
  mounted() {
    this.componentID = this._uid;
    this.forceRerender();
  },
  methods: {
    forceRerender() {
      this.childKeyIdx++;
    },
  },
};
</script>
